export type MerchantAdminTheme = {
  headingFontFamily: HeadingFontFamily;
};

const merchantAdminTheme: MerchantAdminTheme = {
  headingFontFamily: 'WoltHeading-Omnes',
};

export type HeadingFontFamily = 'WoltHeading-Omnes' | 'WoltHeading-October' | 'WoltHeading-M-Plus-Rounded-1c';

const resolveHeadingFont = (locale = ''): HeadingFontFamily => {
  const languageCode = locale.split(/[-_]/)[0].toLowerCase();

  if (languageCode === 'ja') {
    return 'WoltHeading-M-Plus-Rounded-1c';
  }

  if (['kk', 'ka', 'el', 'he'].includes(languageCode)) {
    return 'WoltHeading-October';
  }

  return 'WoltHeading-Omnes';
};

export const createMerchantAdminTheme = (locale: string): MerchantAdminTheme => {
  return {
    ...merchantAdminTheme,
    headingFontFamily: resolveHeadingFont(locale),
  };
};
